import styled, { css } from 'styled-components'
import { routingPaths } from '../../data/Constants'
import { Translations } from '../../data/Translations'
import { INewsArticle } from '../../prismicTypes'
import Typography from '../../styles/typography'
import { getISDateFormat } from '../../utils/helpers'
import { getNewsArticleSEOData } from '../../utils/seoHelpers'
import InlineLink from '../Links/InlineLink'
import NextHeader from '../NextHeader'
import PrismicRichText from '../PrismicRichText'

export interface INewsArticleProps {
  articlePage: INewsArticle.IProps
}

export function NewsArticle({ articlePage }: INewsArticleProps) {
  const {
    data: { title, article_body, published_date },
  } = articlePage

  return (
    <>
      <NextHeader seoData={getNewsArticleSEOData(articlePage)} />
      <SCArticleContainer>
        <SCContentColumn>
          <div>
            <InlineLink href="/">{Translations.is.navigation.backHome}</InlineLink>
          </div>
          <SCDateField> {getISDateFormat(published_date)}</SCDateField>
          <SCHeaderLabel>{title[0].text}</SCHeaderLabel>
          <div>
            <PrismicRichText richText={article_body} />
          </div>
        </SCContentColumn>
        <SCFlex>
          <InlineLink href={`/${routingPaths.news}`} passHref>
            {Translations.is.contentSections.newsArticles.seeAll}
          </InlineLink>
          <InlineLink href="/" passHref>
            {Translations.is.navigation.backHome}
          </InlineLink>
        </SCFlex>
      </SCArticleContainer>
    </>
  )
}

const SCArticleContainer = styled.div`
  ${({ theme: { containerWidths } }) => css`
    max-width: ${containerWidths.medium};
    width: 70%;
    margin: auto;
  `}
`

const SCFlex = styled.div`
  margin-top: 9rem;
  display: flex;
  justify-content: space-between;
`

const SCDateField = styled.div`
  ${Typography.pSmall}
  margin-top: 2rem;
`
const SCHeaderLabel = styled.div`
  ${Typography.h3}
  margin-top: 2rem;
  margin-bottom: 2rem;
`

const SCContentColumn = styled.div`
  ${({ theme: { breakpoints } }) => css`
    @media screen and (min-width: ${breakpoints.tabletMin}) {
      margin-top: 3rem;
    }
  `}
`
